module.exports = __webpack_public_path__ + "static/book-1000Vocabulary-64c4a26fb7060f64688b14cee2879c89.png";